import React, { useState } from 'react';
import { useReservations } from '../ReservationContext';

const WaitlistModal = ({ isOpen, onClose }) => {
  const { loading, addToWaitlist } = useReservations();

  const [formData, setFormData] = useState({
    party_size: 2,
    customer_name: '',
    customer_phone: '',
    notes: '',
    seating_preference: '',
  });

  const handleSubmit = async () => {
    const success = await addToWaitlist(formData);
    if (success) {
      setFormData({
        party_size: 2,
        customer_name: '',
        customer_phone: '',
        notes: '',
        seating_preference: '',
      });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-walkin" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Walk-In</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="walkin-content">
          <div className="party-size-large">
            <label>Party Size</label>
            <div className="party-buttons">
              {[1, 2, 3, 4, 5, 6].map(size => (
                <button
                  key={size}
                  className={`party-size-btn ${formData.party_size === size ? 'active' : ''}`}
                  onClick={() => setFormData({ ...formData, party_size: size })}
                >
                  {size}
                </button>
              ))}
              <button
                className={`party-size-btn ${formData.party_size > 6 ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, party_size: 7 })}
              >
                7+
              </button>
            </div>
            {formData.party_size > 6 && (
              <input
                type="number"
                min="7"
                value={formData.party_size}
                onChange={(e) => setFormData({ ...formData, party_size: parseInt(e.target.value) || 7 })}
                className="party-size-input"
              />
            )}
          </div>

          <div className="walkin-fields">
            <div className="form-group">
              <label>Name (optional)</label>
              <input
                type="text"
                value={formData.customer_name}
                onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
                placeholder="Guest name"
              />
            </div>
            <div className="form-group">
              <label>Phone (optional)</label>
              <input
                type="tel"
                value={formData.customer_phone}
                onChange={(e) => setFormData({ ...formData, customer_phone: e.target.value })}
                placeholder="For text notifications"
              />
            </div>
            <div className="form-group">
              <label>Notes</label>
              <input
                type="text"
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                placeholder="High chair, patio, etc."
              />
            </div>
          </div>

          <div className="walkin-actions">
            <button
              className="btn btn-large btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add to Waitlist'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistModal;
